module.exports = __webpack_public_path__ + "img/85.ce16250f.jpg";